const GG_CAMPSITE_AREAS=[
  {
    "name": "Licklog Falls Campground",
    "lat": 34.929113199999996,
    "lon": -83.13008687272728,
    "source": "https://www.openstreetmap.org/way/1505388922",
    "version": "1",
    "sourceUpdated": "2026-04-28T22:52:34Z",
    "positionNote": "mean of mapped boundary vertices",
    "tableRockMile": 67.9,
    "mileageReference": "FarOut guide screenshot 50"
  },
  {
    "name": "Burrells Ford Campground",
    "lat": 34.96857834,
    "lon": -83.11899728399997,
    "source": "https://www.openstreetmap.org/way/1089973991",
    "version": "1",
    "sourceUpdated": "2022-08-29T01:38:48Z",
    "positionNote": "mean of mapped boundary vertices",
    "tableRockMile": 60.7,
    "mileageReference": "FarOut guide screenshot 44"
  },
  {
    "name": "Fish Hatchery Camp",
    "lat": 34.9918727,
    "lon": -83.0593563,
    "source": "https://www.openstreetmap.org/node/9057954025",
    "version": "1",
    "sourceUpdated": "2021-09-03T06:50:31Z",
    "positionNote": "Mapped point; not field verified",
    "tableRockMile": 53.8,
    "mileageReference": "FarOut guide screenshot 38"
  },
  {
    "name": "Coley Creek Campsite",
    "lat": 35.0444122,
    "lon": -82.9716582,
    "source": "https://www.openstreetmap.org/node/6355592894",
    "version": "4",
    "sourceUpdated": "2025-08-01T16:28:54Z",
    "positionNote": "Mapped point; not field verified",
    "tableRockMile": 40.9,
    "mileageReference": "FarOut guide screenshot 30"
  },
  {
    "name": "Glenn Hilliard Campsite",
    "lat": 35.053654,
    "lon": -82.9638442,
    "source": "https://www.openstreetmap.org/node/11806078150",
    "version": "1",
    "sourceUpdated": "2024-04-10T01:10:18Z",
    "positionNote": "Mapped point; not field verified",
    "tableRockMile": 39.9,
    "mileageReference": "FarOut guide screenshot 28"
  },
  {
    "name": "Bearcamp Creek Campsite",
    "lat": 35.0486157,
    "lon": -82.9523279,
    "source": "https://www.openstreetmap.org/node/6355584749",
    "version": "4",
    "sourceUpdated": "2024-04-10T01:10:18Z",
    "positionNote": "Mapped point; not field verified",
    "tableRockMile": 38.9,
    "mileageReference": "FarOut guide screenshot 29"
  },
  {
    "name": "Bear Gap Campsite",
    "lat": 35.0593286,
    "lon": -82.9202852,
    "source": "https://www.openstreetmap.org/node/6784385517",
    "version": "2",
    "sourceUpdated": "2022-04-27T14:48:08Z",
    "positionNote": "Mapped point; not field verified",
    "tableRockMile": 33.7,
    "mileageReference": "FarOut guide screenshot 27"
  },
  {
    "name": "Toxaway Creek Campsites",
    "lat": 35.0708445,
    "lon": -82.886087,
    "source": "https://www.openstreetmap.org/node/6804577590",
    "version": "1",
    "sourceUpdated": "2019-09-18T04:26:53Z",
    "positionNote": "position approximated",
    "tableRockMile": 27.7,
    "mileageReference": "FarOut guide screenshot 22"
  },
  {
    "name": "Rock Creek Campsite",
    "lat": 35.0594362,
    "lon": -82.8895471,
    "source": "https://www.openstreetmap.org/node/6804577591",
    "version": "1",
    "sourceUpdated": "2019-09-18T04:26:53Z",
    "positionNote": "position approximated",
    "tableRockMile": 26.5,
    "mileageReference": "FarOut guide screenshot 19"
  },
  {
    "name": "Laurel Fork Campsite",
    "lat": 35.0314782,
    "lon": -82.8930396,
    "source": "https://www.openstreetmap.org/node/6993018065",
    "version": "2",
    "sourceUpdated": "2023-03-16T17:59:22Z",
    "positionNote": "Mapped point; not field verified",
    "tableRockMile": 22.1,
    "mileageReference": "FarOut guide screenshot 18"
  },
  {
    "name": "Virginia Hawkins Campsite",
    "lat": 35.0415623,
    "lon": -82.8513398,
    "source": "https://www.openstreetmap.org/node/6993018067",
    "version": "2",
    "sourceUpdated": "2020-02-26T22:40:16Z",
    "positionNote": "Mapped point; not field verified",
    "tableRockMile": 19.3,
    "mileageReference": "FarOut guide screenshot 16"
  },
  {
    "name": "Cantrell Campsite",
    "lat": 35.0515554,
    "lon": -82.769377,
    "source": "https://www.openstreetmap.org/node/6993018066",
    "version": "1",
    "sourceUpdated": "2019-11-20T16:45:05Z",
    "positionNote": "Mapped point; not field verified",
    "tableRockMile": 8.6,
    "mileageReference": "FarOut guide screenshot 13"
  }
];
